import React, { useState, useEffect } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import swal from "sweetalert";
import AuthApi from "../../Services/Authapi";
import TextField from '@material-ui/core/TextField';
import AuthCheckComponent from '../../Layouts/Token';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import EmailEditor from 'react-email-editor';
import { useTheme } from '../../../ThemeContext';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import {
    EMAIL_EDITOR_MIN_HEIGHT,
    getEmailEditorAppearance,
    getEmailEditorFrameStyle,
    getEmailEditorSurfaceStyles,
    prepareDefaultButtonDesign,
} from './emailTemplateEditorTheme';

const iniLatter = {
    title: '',
    texteditor: '',
    template_design: '',
    templates: []
}

const Latter = (props) => {
    const classes = props;
    const { darkMode } = useTheme();
    const [doc, setDoc] = useState(iniLatter);
    const [formErrors, setFormErrors] = useState({});
    const emailEditorRef = React.useRef(null);
    const isApplyingDefaultButtonStyleRef = React.useRef(false);
    const editorScopeClassName = 'template-editor-add';

    const fontConfig = {
        fonts: {
            showDefaultFonts: true,
            customFonts: [
                { label: 'Arial', value: 'Arial, sans-serif' },
                { label: 'Georgia', value: 'Georgia, serif' },
                { label: 'Times New Roman', value: 'Times New Roman, serif' },
                { label: 'Verdana', value: 'Verdana, sans-serif' },
                { label: 'Courier New', value: '"Courier New", monospace' },
                { label: 'Tahoma', value: 'Tahoma, sans-serif' },
                { label: 'Trebuchet MS', value: '"Trebuchet MS", sans-serif' },
                { label: 'Lucida Sans', value: '"Lucida Sans", sans-serif' },
                { label: 'Roboto', value: 'Roboto, sans-serif' },
                { label: 'Open Sans', value: '"Open Sans", sans-serif' },
                { label: 'Lato', value: 'Lato, sans-serif' },
                { label: 'Montserrat', value: 'Montserrat, sans-serif' },
                { label: 'Oswald', value: 'Oswald, sans-serif' },
                { label: 'Raleway', value: 'Raleway, sans-serif' },
                { label: 'Merriweather', value: 'Merriweather, serif' },
                { label: 'Ubuntu', value: 'Ubuntu, sans-serif' },
                { label: 'Playfair Display', value: 'Playfair Display, serif' },
                { label: 'Poppins', value: 'Poppins, sans-serif' },
                { label: 'Quicksand', value: 'Quicksand, sans-serif' },
                { label: 'Roboto Slab', value: 'Roboto Slab, serif' },
                { label: 'Source Sans Pro', value: 'Source Sans Pro, sans-serif' },
                { label: 'Varela Round', value: 'Varela Round, sans-serif' },
                { label: 'Work Sans', value: 'Work Sans, sans-serif' },
                { label: 'Dancing Script', value: '"Dancing Script", cursive' },
                { label: 'Pacifico', value: '"Pacifico", cursive' },
                { label: 'Great Vibes', value: '"Great Vibes", cursive' },
                { label: 'Lobster', value: '"Lobster", cursive' },
                { label: 'Bebas Neue', value: '"Bebas Neue", cursive' },
                { label: 'Cinzel', value: 'Cinzel, serif' },
                { label: 'Abril Fatface', value: '"Abril Fatface", cursive' },
                { label: 'Amatic SC', value: '"Amatic SC", cursive' },
                { label: 'Josefin Sans', value: '"Josefin Sans", sans-serif' },
                { label: 'Playfair Display SC', value: '"Playfair Display SC", serif' },
            ],
        },
    };

    useEffect(() => {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
    }, [props]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDoc({ ...doc, [name]: value });
        setFormErrors((prev) => {
            if (!prev[name]) {
                return prev;
            }

            const nextErrors = { ...prev };
            delete nextErrors[name];
            return nextErrors;
        });
    };

    const getApiErrorMessage = (response) => {
        if (!response) {
            return "Something went wrong, Please try later!";
        }

        if (typeof response.message === 'string' && response.message.trim()) {
            return response.message;
        }

        if (typeof response.error === 'string' && response.error.trim()) {
            return response.error;
        }

        if (Array.isArray(response.errors) && response.errors.length > 0) {
            return response.errors.join(', ');
        }

        if (response.errors && typeof response.errors === 'object') {
            return Object.values(response.errors).flat().join(', ');
        }

        return "Something went wrong, Please try later!";
    };

    const sanitizeTemplateHtml = (html) => {
        if (typeof html !== 'string' || !html.trim()) {
            return '<p></p>';
        }

        return html
            .replace(/href=""/gi, 'href="#"')
            .replace(/href=''/gi, "href='#'");
    };

    const validate = (values) => {
        let errors = {};
        const regex = /^[a-zA-Z]/;

        if (!values.title) {
            errors.title = "Cannot be blank";
        } else if (!regex.test(values.title)) {
            errors.title = "Invalid title format";
        }

        values.templates.forEach((template, index) => {
            if (!template.label) {
                errors[`templateLabel${index}`] = "Template label cannot be blank";
            }
            if (!template.type) {
                errors[`templateType${index}`] = "Template type cannot be blank";
            }
        });

        return errors;
    };

    const showValidationPopup = (errors) => {
        const fieldNames = [];

        if (errors.title) {
            fieldNames.push('Title');
        }

        Object.keys(errors).forEach((key) => {
            if (key.startsWith('templateLabel')) {
                fieldNames.push('Template Label');
            }
            if (key.startsWith('templateType')) {
                fieldNames.push('Template Type');
            }
        });

        if (fieldNames.length === 0) {
            return;
        }

        swal({
            title: 'Required Fields',
            text: `Please fill: ${[...new Set(fieldNames)].join(', ')}`,
            icon: 'warning',
            button: 'OK',
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let updatedDoc = doc;

        if (emailEditorRef.current?.editor) {
            updatedDoc = await new Promise((resolve) => {
                emailEditorRef.current.editor.exportHtml((data) => {
                    const { design, html } = data;
                    resolve({
                        ...doc,
                        texteditor: sanitizeTemplateHtml(html),
                        template_design: JSON.stringify(design),
                    });
                });
            });
            setDoc(updatedDoc);
        }

        const errors = validate(updatedDoc);
        setFormErrors(errors);

        if (Object.keys(errors).length > 0) {
            showValidationPopup(errors);
            return;
        }

        createLeaves(updatedDoc);
    };

    const createLeaves = async (payload) => {
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            width: "10%",
            content: createSwalLoaderNode()
        });
        try {
            let create = await AuthApi.Templatepostdata(payload);
            swal.close();
            if (create && create.status === true) {
                swal("Success", "Template added successfully", "success").then(() => {
                    props.history.push("/templates");
                });
            } else {
                swal({
                    title: "OOPS!",
                    icon: "error",
                    text: getApiErrorMessage(create),
                });
            }
        } catch (error) {
            swal.close();
            console.error("Error updating role:", error);
            swal("Error", "An unexpected error occurred", "error");
        }
    };

    const addTemplateField = () => {
        setDoc({ ...doc, templates: [...doc.templates, { label: '', type: '' }] });
    };

    const removeTemplateField = (index) => {
        const newTemplates = doc.templates.filter((_, i) => i !== index);
        setDoc({ ...doc, templates: newTemplates });
    };

    const handleEditorReady = (editor) => {
        editor.addEventListener('design:updated', () => {
            if (isApplyingDefaultButtonStyleRef.current) {
                isApplyingDefaultButtonStyleRef.current = false;
                return;
            }

            editor.saveDesign((design) => {
                const normalizedDesign = prepareDefaultButtonDesign(design);
                if (!normalizedDesign) {
                    return;
                }

                isApplyingDefaultButtonStyleRef.current = true;
                editor.loadDesign(normalizedDesign);
            });
        });
    };

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <style>{getEmailEditorSurfaceStyles(darkMode, editorScopeClassName)}</style>
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div>
                        <div className="holiday-breadcrumb-card">
                            <Breadcrumb {...props} primaryPageName="User Template" primaryPageLink="/templates" isSecondaryPage={true} secondaryPageName="Add Template" />
                        </div>
                        <Grid container className={classes.root} spacing={2}>
                            <Grid item xs={12}>
                                <Card className={classes.root}>
                                    <CardContent className="common-form-fields">
                                        <Typography variant="h2" className="common-form-page-title" style={{ paddingTop: 0, paddingLeft: 0, paddingBottom: 0 }}>Generate Template</Typography>
                                        <form className={classes.form} onSubmit={handleSubmit}>
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        id="outlined-basic"
                                                        label="Title"
                                                        name="title"
                                                        variant="outlined"
                                                        error={formErrors.title && true}
                                                        value={doc.title}
                                                        onChange={handleChange}
                                                        className={formErrors.title && "input-error"}
                                                    />
                                                    {formErrors.title && (
                                                        <span className="error">{formErrors.title}</span>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={12}>
                                                    <div style={getEmailEditorFrameStyle(darkMode)}>
                                                        <div className={editorScopeClassName}>
                                                            <EmailEditor
                                                                ref={emailEditorRef}
                                                                minHeight={EMAIL_EDITOR_MIN_HEIGHT}
                                                                onReady={handleEditorReady}
                                                                options={{
                                                                    appearance: getEmailEditorAppearance(darkMode),
                                                                    features: {
                                                                        preview: true,
                                                                        stockImages: true,
                                                                    },
                                                                    fontFamily: {
                                                                        label: 'Arial',
                                                                        value: 'Arial, sans-serif',
                                                                    },
                                                                    mergeTags: {},
                                                                    customJS: [],
                                                                    fonts: fontConfig.fonts,
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>

                                            {/* <Grid container className={classes.root} spacing={5}> */}
                                            {doc.templates.map((template, index) => (
                                                <Grid container spacing={5} key={index}>
                                                    <Grid item xs={5}>
                                                        <TextField
                                                            fullWidth
                                                            id={`outlined-template-label-${index}`}
                                                            label="Template Label"
                                                            name={`templateLabel${index}`}
                                                            variant="outlined"
                                                            error={formErrors[`templateLabel${index}`] && true}
                                                            value={template.label}
                                                            onChange={(e) => {
                                                                const newTemplates = [...doc.templates];
                                                                newTemplates[index].label = e.target.value;
                                                                setDoc({ ...doc, templates: newTemplates });
                                                            }}
                                                            className={formErrors[`templateLabel${index}`] && "input-error"}
                                                        />
                                                        {formErrors[`templateLabel${index}`] && (
                                                            <span className="error">{formErrors[`templateLabel${index}`]}</span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <FormControl fullWidth error={formErrors[`templateType${index}`] && true}>
                                                            <InputLabel id={`template-type-label-${index}`}>Template Type</InputLabel>
                                                            <Select
                                                                labelId={`template-type-label-${index}`}
                                                                id={`outlined-template-type-${index}`}
                                                                name={`templateType${index}`}
                                                                label="Template Type"
                                                                value={template.type}
                                                                onChange={(e) => {
                                                                    const newTemplates = [...doc.templates];
                                                                    newTemplates[index].type = e.target.value;
                                                                    setDoc({ ...doc, templates: newTemplates });
                                                                }}
                                                                className={formErrors[`templateType${index}`] && "input-error"}
                                                            >
                                                                <MenuItem value="text">Text</MenuItem>
                                                                <MenuItem value="date">Date</MenuItem>
                                                                <MenuItem value="email">Email</MenuItem>
                                                                <MenuItem value="month">Month</MenuItem>
                                                                <MenuItem value="number">Number</MenuItem>
                                                                <MenuItem value="textarea">Textarea </MenuItem>
                                                                <MenuItem value="password">Password</MenuItem>
                                                                <MenuItem value="time">Time</MenuItem>
                                                                <MenuItem value="color">Color</MenuItem>
                                                                <MenuItem value="hidden">Hidden</MenuItem>
                                                                <MenuItem value="submit">Submit</MenuItem>
                                                                <MenuItem value="radio">Radio</MenuItem>
                                                                <MenuItem value="checkbox">Checkbox</MenuItem>
                                                                <MenuItem value="file">Image</MenuItem>
                                                            </Select>
                                                            {formErrors[`templateType${index}`] && (
                                                                <span className="error">{formErrors[`templateType${index}`]}</span>
                                                            )}
                                                        </FormControl>
                                                    </Grid>
                                                    {template.type === 'radio' && (
                                                        <Grid item xs={10}>
                                                            {template.options && template.options.map((option, optIndex) => (
                                                                <Grid container spacing={2} key={optIndex}>
                                                                    <Grid item xs={8}>
                                                                        <TextField
                                                                            fullWidth
                                                                            id={`outlined-radio-option-${index}-${optIndex}`}
                                                                            label={`Option ${optIndex + 1}`}
                                                                            value={option}
                                                                            onChange={(e) => {
                                                                                const newTemplates = [...doc.templates];
                                                                                newTemplates[index].options[optIndex] = e.target.value;
                                                                                setDoc({ ...doc, templates: newTemplates });
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                        <Button
                                                                            onClick={() => {
                                                                                const newTemplates = [...doc.templates];
                                                                                newTemplates[index].options.splice(optIndex, 1);
                                                                                setDoc({ ...doc, templates: newTemplates });
                                                                            }}
                                                                            variant="contained"
                                                                            style={{
                                                                                color: "#fff",
                                                                                backgroundColor: "#d12c2c",
                                                                                marginTop: "10px",
                                                                                textTransform: 'capitalize'
                                                                            }}>
                                                                            Remove
                                                                        </Button>
                                                                    </Grid>
                                                                </Grid>
                                                            ))}
                                                            <Button
                                                                onClick={() => {
                                                                    const newTemplates = [...doc.templates];
                                                                    if (!newTemplates[index].options) {
                                                                        newTemplates[index].options = [];
                                                                    }
                                                                    newTemplates[index].options.push('');
                                                                    setDoc({ ...doc, templates: newTemplates });
                                                                }}
                                                                variant="contained"
                                                                color="primary"
                                                                style={{ marginTop: "10px", textTransform: 'capitalize' }}>
                                                                Add Option
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                    {template.type === 'checkbox' && (
                                                        <Grid item xs={10}>
                                                            {template.options && template.options.map((option, optIndex) => (
                                                                <Grid container spacing={2} key={optIndex}>
                                                                    <Grid item xs={8}>
                                                                        <TextField
                                                                            fullWidth
                                                                            id={`outlined-checkbox-option-${index}-${optIndex}`}
                                                                            label={`Option ${optIndex + 1}`}
                                                                            value={option}
                                                                            onChange={(e) => {
                                                                                const newTemplates = [...doc.templates];
                                                                                newTemplates[index].options[optIndex] = e.target.value;
                                                                                setDoc({ ...doc, templates: newTemplates });
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                        <Button
                                                                            onClick={() => {
                                                                                const newTemplates = [...doc.templates];
                                                                                newTemplates[index].options.splice(optIndex, 1);
                                                                                setDoc({ ...doc, templates: newTemplates });
                                                                            }}
                                                                            variant="contained"
                                                                            style={{
                                                                                color: "#fff",
                                                                                backgroundColor: "#d12c2c",
                                                                                marginTop: "10px",
                                                                                textTransform: 'capitalize'
                                                                            }}>
                                                                            Remove
                                                                        </Button>
                                                                    </Grid>
                                                                </Grid>
                                                            ))}
                                                            <Button
                                                                onClick={() => {
                                                                    const newTemplates = [...doc.templates];
                                                                    if (!newTemplates[index].options) {
                                                                        newTemplates[index].options = [];
                                                                    }
                                                                    newTemplates[index].options.push('');
                                                                    setDoc({ ...doc, templates: newTemplates });
                                                                }}
                                                                variant="contained"
                                                                color="primary"
                                                                style={{ marginTop: "10px", textTransform: 'capitalize' }}>
                                                                Add Option
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                    <Grid item xs={2}>
                                                        <Button
                                                            onClick={() => removeTemplateField(index)}
                                                            variant="contained"
                                                            style={{
                                                                color: "#fff",
                                                                backgroundColor: "#d12c2c",
                                                                marginTop: "10px",
                                                                textTransform: 'capitalize'
                                                            }}>
                                                            Delete
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            ))}
                                            {/* <Grid item xs={12} style={{ marginTop: "10px" }}>
                                                <Button onClick={addTemplateField} variant="contained" color="primary" className="common-action-button" style={{ textTransform: 'capitalize' }}>
                                                    Add Input Field
                                                </Button>
                                            </Grid> */}
                                            {/* </Grid> */}
                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={4}>
                                                    <Button type="submit" className="btn-success" style={{ marginTop: "10px", float: 'left', marginBottom: "15px", textTransform: 'capitalize' }} variant="contained" color="primary">Save</Button>
                                                    <Button type="button" className="btn-cancel" style={{ marginTop: "10px", float: 'left', marginBottom: "15px", textTransform: 'capitalize' }} onClick={(e) => { e.preventDefault(); props.history.push('/templates') }}>Cancel</Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                } />

            <Footer />
        </div>
    )
}

export default Latter;
